// Formatting helpers
const CUR_LOCALE = {
  INR: "en-IN",
  USD: "en-US",
  EUR: "de-DE",
  GBP: "en-GB",
};

export function fmtCurrency(value, currency = "INR") {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat(CUR_LOCALE[currency] || "en-IN", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `${currency} ${n.toLocaleString()}`;
  }
}

export function fmtCompact(value, currency = "INR") {
  const n = Number(value || 0);
  const symbol = currency === "INR" ? "₹" : currency === "USD" ? "$" : `${currency} `;
  if (n >= 1e7) return `${symbol}${(n / 1e7).toFixed(1)}Cr`;
  if (n >= 1e5) return `${symbol}${(n / 1e5).toFixed(1)}L`;
  if (n >= 1e3) return `${symbol}${(n / 1e3).toFixed(1)}k`;
  return `${symbol}${n.toLocaleString()}`;
}

export function fmtDate(s) {
  if (!s) return "";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
}

export function initials(name = "?") {
  return (name || "?").trim().slice(0, 1).toUpperCase();
}
